import { Component, OnInit, Inject } from '@angular/core';
import { PaymentService } from 'src/app/services/http/business/payment/payment.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ICompany } from 'src/app/interfaces/company';
import { CompanyService } from 'src/app/services/http/business/company/company.service';
import { CouponService } from 'src/app/services/http/business/coupon/coupon.service';
import { InvoiceRejectService } from 'src/app/services/http/business/invoiceReject/invoice-reject.service';
import { SnackBarService } from 'src/app/services/common/snackBar.service';
import { SoundEnum } from 'src/app/enums/sound.enum';
import { ErrorsService } from 'src/app/services/common/errors.service';
import { IError } from 'src/app/interfaces/error.interface';

@Component({
  selector: 'app-pay-to-wallet-person',
  templateUrl: './pay-to-wallet-person.component.html',
  styleUrls: ['./pay-to-wallet-person.component.css']
})
export class PayToWalletPersonComponent implements OnInit {

  param: any;
  errorList: IError[] = [];
  errObject: any;
  errors = new Array();
  couponList = [];
  wallet: any;
  form: FormGroup;
  companyList: ICompany;

  constructor(
    public dialogRef: MatDialogRef<PayToWalletPersonComponent>,
    private fb: FormBuilder,
    private companyService: CompanyService,
    private errorService: ErrorsService,
    private couponService: CouponService,
    private invoiceReject: InvoiceRejectService,
    private snackBar: SnackBarService,
    private paymentService: PaymentService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    console.log(this.data);

    this.createForm();
    this.getWallet();
    this.getCompanyList();
  }

  createForm() {
    this.form = this.fb.group({
      NationalCode: [this.data.NationalCode],
      Amount: [null, Validators.required],
      CompanyEncryptId: [null, Validators.required]
    });
  }

  getUserCouponsStudent() {

    this.couponService.listAllUser(this.data.NationalCode).subscribe(res => {
      this.couponList = res.DataList;
    }, () => {

    })
  }

  getCompanyList() {
    this.companyService.list(0, 0).subscribe(res => {
      this.companyList = res.DataList;
    });
  }

  getWallet() {
    this.paymentService.getWallet(this.data.NationalCode).subscribe(
      res => {
        this.wallet = res.CreditCompany;
        // this.form.controls['Amount'].patchValue(res.CreditCompany);
        // this.form.controls['Amount'].setValidators(Validators.max(res.CreditCompany));
      }
    );
  }

  submit(data: any) {
    this.invoiceReject.payToWalletPerson(data).subscribe(() => {
      this.dialogRef.close();
      this.snackBar.OpenSnackBar(
        "پرداخت به اعتبار با موفقت انجام شد و به اعتبار اضافه گردید",
        "ok",
        5000,
        SoundEnum.beep
      );
    },
    err => {
      // this.errObject = this.errorService.getError(err);
      // this.param = this.errorService.objectError(this.errObject);
      // this.errors = this.errorService.returnError(err);
      this.errorList = this.errorService.getErrorList(err.error);
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
